module.exports = __webpack_public_path__ + "media/step4_animation.a649da1e.mp4";